/**
 * Quote Form 2026 (Shopify Forms ID 1121777) — Shadow DOM integration.
 * Modeled after contact-form-2026.js from the contact template.
 * Tagging Name, Email, Company, URL, Platform, Timeline fields for side-by-side grid rows.
 */
(function () {
  const FORM_ID = '1121777';
  const FORM_ROOT_SELECTOR = '[data-forms-id="forms-root-' + FORM_ID + '"]';
  const STYLE_ID = 'bb-quote-form-2026-styles';
  const STYLE_KEY = 'bb-quote-form-2026';

  const shell = document.querySelector('.quote-form-section__form-shell[data-bb-quote-form-id="' + FORM_ID + '"]') || document.querySelector('#QuoteForm');
  if (!shell) return;

  const cssUrl = shell.getAttribute('data-bb-quote-form-css') || (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'assets/quote-form-2026-shadow.css' : '');
  if (!cssUrl) return;

  let cssTextPromise;

  function getCssText() {
    if (!cssTextPromise) {
      cssTextPromise = fetch(cssUrl)
        .then(function (response) {
          if (!response.ok) throw new Error('Failed to load Quote Form 2026 CSS');
          return response.text();
        })
        .catch(function () {
          return '';
        });
    }
    return cssTextPromise;
  }

  function getLayoutRoot(shadowRoot) {
    return (
      shadowRoot.querySelector('[data-testid="fields-container"]') ||
      shadowRoot.querySelector('form') ||
      shadowRoot.querySelector('[class*="_inline"]') ||
      shadowRoot.querySelector('[data-testid="form-container"]') ||
      shadowRoot.querySelector('section') ||
      shadowRoot.firstElementChild
    );
  }

  function findFieldWrapper(input, layoutRoot) {
    let node = input;
    while (node && node !== layoutRoot) {
      if (node.parentElement === layoutRoot) return node;
      node = node.parentElement;
    }
    return (
      input.closest('[data-testid="field-wrapper"]') ||
      input.closest('[class*="formField"]') ||
      input.parentElement
    );
  }

  function getLabelText(input, shadowRoot) {
    if (!input.id) return '';
    const label = shadowRoot.querySelector('label[for="' + CSS.escape(input.id) + '"]');
    return label ? label.textContent.trim().toLowerCase() : '';
  }

  function tagQuoteFields(shadowRoot) {
    const layoutRoot = getLayoutRoot(shadowRoot);
    if (!layoutRoot) return;

    const inputs = shadowRoot.querySelectorAll('input:not([type="hidden"]), select');
    let nameWrap = null;
    let emailWrap = null;
    let companyWrap = null;
    let urlWrap = null;
    let platformWrap = null;
    let timelineWrap = null;

    inputs.forEach(function (input) {
      const placeholder = (input.getAttribute('placeholder') || '').toLowerCase();
      const nameAttr = (input.getAttribute('name') || '').toLowerCase();
      const ariaLabel = (input.getAttribute('aria-label') || '').toLowerCase();
      const labelText = getLabelText(input, shadowRoot);
      const wrap = findFieldWrapper(input, layoutRoot);

      // Name
      if (
        !nameWrap &&
        (placeholder.includes('full name') ||
          ariaLabel.includes('full name') ||
          labelText.includes('full name') ||
          placeholder.includes('your name') ||
          (labelText.includes('name') && !placeholder.includes('company') && !labelText.includes('company')))
      ) {
        nameWrap = wrap;
      }

      // Email
      if (
        !emailWrap &&
        (input.type === 'email' ||
          placeholder.includes('email') ||
          nameAttr.includes('email') ||
          ariaLabel.includes('email') ||
          labelText.includes('email'))
      ) {
        emailWrap = wrap;
      }

      // Company
      if (
        !companyWrap &&
        (placeholder.includes('company') ||
          nameAttr.includes('company') ||
          ariaLabel.includes('company') ||
          labelText.includes('company') ||
          labelText.includes('brand'))
      ) {
        companyWrap = wrap;
      }

      // URL
      if (
        !urlWrap &&
        (input.type === 'url' ||
          placeholder.includes('website') ||
          placeholder.includes('http') ||
          nameAttr.includes('url') ||
          ariaLabel.includes('url') ||
          labelText.includes('website') ||
          labelText.includes('url'))
      ) {
        urlWrap = wrap;
      }

      // Platform
      if (
        !platformWrap &&
        input.tagName === 'SELECT' &&
        (labelText.includes('running on') ||
          labelText.includes('platform') ||
          nameAttr.includes('platform') ||
          ariaLabel.includes('platform'))
      ) {
        platformWrap = wrap;
      }

      // Timeline
      if (
        !timelineWrap &&
        input.tagName === 'SELECT' &&
        (labelText.includes('live') ||
          labelText.includes('timeline') ||
          labelText.includes('when do you need') ||
          nameAttr.includes('timeline') ||
          ariaLabel.includes('timeline'))
      ) {
        timelineWrap = wrap;
      }
    });

    layoutRoot.classList.add('bb-qf-fields-layout');
    if (nameWrap) nameWrap.classList.add('bb-qf-field--name');
    if (emailWrap) emailWrap.classList.add('bb-qf-field--email');
    if (companyWrap) companyWrap.classList.add('bb-qf-field--company');
    if (urlWrap) urlWrap.classList.add('bb-qf-field--url');
    if (platformWrap) platformWrap.classList.add('bb-qf-field--platform');
    if (timelineWrap) timelineWrap.classList.add('bb-qf-field--timeline');
  }

  function injectStyles(shadowRoot, cssText) {
    if (!cssText) return;
    let style = shadowRoot.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      shadowRoot.appendChild(style);
    }
    style.textContent = cssText;
  }

  function findEmbed() {
    const formRoot = shell.querySelector(FORM_ROOT_SELECTOR) || shell.querySelector('shopify-forms-embed, form-embed');
    if (!formRoot) return null;
    if (formRoot.matches('shopify-forms-embed, form-embed')) return formRoot;
    return formRoot.querySelector('shopify-forms-embed, form-embed');
  }

  function stripFormInputFieldClasses(shadowRoot) {
    shadowRoot.querySelectorAll('[class*="_formInputField_"]').forEach(function (el) {
      if (
        el.closest('[class*="_selectContainer_"]') ||
        el.querySelector('[class*="_selectContainer_"]') ||
        el.querySelector('input[type="file"]') ||
        (el.className && typeof el.className === 'string' && el.className.toLowerCase().indexOf('file') !== -1)
      ) {
        return;
      }
      el.classList.forEach(function (className) {
        if (className.indexOf('_formInputField_') === 0) {
          el.classList.remove(className);
        }
      });
    });
  }

  function hideNativeSelects(shadowRoot) {
    shadowRoot.querySelectorAll('button[class*="_selectToggle_"], [class*="_selectContainer_"]').forEach(function (toggle) {
      const parent = toggle.closest('[class*="_selectContainer_"]') || toggle.closest('[data-testid="field-wrapper"]') || toggle.parentElement;
      if (parent) {
        parent.querySelectorAll('select').forEach(function (select) {
          select.style.display = 'none';
        });
      }
    });
  }

  function enhanceEmbed(embed, cssText) {
    if (!embed.shadowRoot) return false;
    injectStyles(embed.shadowRoot, cssText);
    stripFormInputFieldClasses(embed.shadowRoot);
    hideNativeSelects(embed.shadowRoot);
    tagQuoteFields(embed.shadowRoot);
    return true;
  }

  function observeShadow(embed) {
    if (!embed.shadowRoot) return;
    const shadowObserver = new MutationObserver(function () {
      stripFormInputFieldClasses(embed.shadowRoot);
      hideNativeSelects(embed.shadowRoot);
      tagQuoteFields(embed.shadowRoot);
    });
    shadowObserver.observe(embed.shadowRoot, { childList: true, subtree: true });
    window.setTimeout(function () {
      shadowObserver.disconnect();
    }, 20000);
  }

  function enhance() {
    const embed = findEmbed();
    if (!embed) return Promise.resolve(false);

    return getCssText().then(function (cssText) {
      if (!cssText) return false;

      window.formStyles = window.formStyles || new Map();
      if (!window.formStyles.has(STYLE_KEY)) {
        window.formStyles.set(STYLE_KEY, cssText);
      }

      if (embed.shadowRoot) {
        enhanceEmbed(embed, cssText);
        observeShadow(embed);
        return true;
      }
      return false;
    });
  }

  enhance().then(function (done) {
    if (done) return;

    const shellObserver = new MutationObserver(function () {
      const embed = findEmbed();
      if (embed && embed.shadowRoot) {
        getCssText().then(function (cssText) {
          if (cssText) enhanceEmbed(embed, cssText);
          observeShadow(embed);
        });
      }
    });

    shellObserver.observe(shell, { childList: true, subtree: true });
    window.setTimeout(function () {
      shellObserver.disconnect();
    }, 20000);
  });
})();
